import tw from 'twin.macro';

const PageContainer = tw.div`bg-swell-gray w-full`;
const Page = tw.div`bg-white`;

export { PageContainer, Page };
